import {
  AxiosResponse,
} from 'axios';
import {
  acceptHMRUpdate,
  defineStore,
} from 'pinia';

import {
  asyncRequestAction,
} from './util/request';

import {
  TGetJobPayload,
  TGetJobResponse,
  getJob,
} from '@/generated/qmulus/axios/core.ts';

export type TJobId = number;
export type TJobInfoKey = string;

export function composeJobInfoKey({
  jobId,
  locationName,
}: {
  jobId: string,
  locationName: string,
}): TJobInfoKey {
  return `${jobId}${locationName}`;
}

export const useJobStore = defineStore('job', {
  state: () => ({
    map: {} as Record<TJobId, TGetJobResponse | undefined>,
    promiseMap: {} as Record<TJobId, Promise<AxiosResponse<TGetJobResponse>> | undefined>,
  }),
  getters: {
    getJobListByIdList: (state) => (jobIdList: TJobId[]) => Object.values(state.map).filter((_job) => jobIdList.includes(_job!.jobId)),
  },
  actions: {
    async loadJobInfo(payload: TGetJobPayload, force = false) {
      return asyncRequestAction({
        id: payload.path.jobId,
        callback: () => getJob(payload),
        record: this.map,
        promiseMap: this.promiseMap,
        force,
      });
    },
    async getCachedJob(jobId: number) {
      const cached = this.map[jobId];

      if (!cached) {
        await this.loadJobInfo(
          {
            path: {
              jobId,
            },
          },
        );
        return this.map[jobId];
      }

      // Refresh unfinished jobs.
      if (cached.status !== 'FINISHED') {
        await this.loadJobInfo(
          {
            path: {
              jobId,
            },
          },
          true,
        );
      }

      return this.map[jobId];
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useJobStore, import.meta.hot));
}
